export const ALO_ACCOUNT_STATE_MANUAL = 'MANUAL';
export const ALO_ACCOUNT_STATE_ACTIVE = 'ACTIVE';
export const ALO_ACCOUNT_STATE_ERROR = 'ERROR';
export const ALO_ACCOUNT_STATE_NOT_FOUND = 'NOT_FOUND';
export const ALO_ACCOUNT_STATE_CLOSED = 'CLOSED';
export const ALO_ACCOUNT_STATE_SUSPENDED = 'SUSPENDED';
export const ALO_ACCOUNT_STATE_PENDING_CONSENT = 'PENDING_CONSENT';

export const ALO_ACCOUNT_ACTIVE_STATE = [ALO_ACCOUNT_STATE_ACTIVE];
export const ALO_ACCOUNT_SUSPENDED_STATE = [
    ALO_ACCOUNT_STATE_SUSPENDED,
    ALO_ACCOUNT_STATE_PENDING_CONSENT
];
export const ALO_ACCOUNT_ERROR_STATE = [
    ALO_ACCOUNT_STATE_MANUAL,
    ALO_ACCOUNT_STATE_ERROR,
    ALO_ACCOUNT_STATE_NOT_FOUND,
    ALO_ACCOUNT_STATE_CLOSED
];



// WEBPACK FOOTER //
// ./src/constants/alo.js